import { render, staticRenderFns } from "./LandPageTotals.vue?vue&type=template&id=c6cbc71e&scoped=true"
import script from "./LandPageTotals.vue?vue&type=script&lang=js"
export * from "./LandPageTotals.vue?vue&type=script&lang=js"
import style0 from "./LandPageTotals.vue?vue&type=style&index=0&id=c6cbc71e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cbc71e",
  null
  
)

export default component.exports